import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/diente/getDientes.php';

export default function getDientes({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}